const mesAtual: number = new Date().getMonth() + 1
const anoAtual: number = new Date().getFullYear()
const ultimoMes: number = mesAtual === 1 ? 12 : mesAtual - 1
const penultimoMes: number = mesAtual <= 2 ? 12 - (2 - mesAtual) : mesAtual - 2
const anoUltimoMes: number = mesAtual === 1 ? anoAtual - 1 : anoAtual
const anoPenultimoMes: number = mesAtual <= 2 ? anoAtual - 1 : anoAtual
const inicioUltimoMes: Date = new Date(anoUltimoMes, ultimoMes - 1, 1)
const fimUltimoMes: Date = new Date(inicioUltimoMes)
fimUltimoMes.setMonth(fimUltimoMes.getMonth() + 1)
fimUltimoMes.setDate(fimUltimoMes.getDate() - 1)

const dataUtils = {
  converterData: (dataString: string) => {
    const data = new Date(dataString)

    let year = data.getFullYear()
    let month = data.getMonth() + 1
    let day = data.getDate()

    let dataFormatada = (day.toString().length < 2 ? '0' + day : '' + day) + '/' + (month.toString().length < 2 ? '0' + month : '' + month) + '/' + year

    return dataFormatada
  },

  converterDataComHoras: (data: Date | null) => {
    if (data) {
      const horas = data.getHours().toString().padStart(2, '0')
      const minutos = data.getMinutes().toString().padStart(2, '0')
      return dataUtils.converterData(data.toString()) + ` ${horas}:${minutos}`
    }
    else {
      return "--"
    }
  },

  dataFormatada: (data: Date | null) => {
    if (data) {
      return dataUtils.converterData(data.toString())
    }
    else {
      return "-"
    }
  },

  mesAtual,
  anoAtual,
  ultimoMes,
  penultimoMes,
  anoUltimoMes,
  anoPenultimoMes,
  inicioUltimoMes,
  fimUltimoMes
}

export default dataUtils